import { render, staticRenderFns } from "./detailForms.vue?vue&type=template&id=cff946e8&"
import script from "./detailForms.vue?vue&type=script&lang=js&"
export * from "./detailForms.vue?vue&type=script&lang=js&"
import style0 from "./detailForms.vue?vue&type=style&index=0&id=cff946e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports